import React from 'react'
import plierImage1 from '../../img/plier/plier-one.png';
import pliermage2 from '../../img/plier/plier-two.png';

const Plier = () => {
    return (
        <div className='plier-container text-center text-white py-3'>
            <div className="compund-main">
                <h1 className='text-white py-2'>Plier</h1>
                <div id="carouselExampleControls" class="carousel slide py-3" data-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img className='d-block w-100' src={plierImage1} alt="First Image Project" />
                        </div>
                        <div class="carousel-item ">
                            <img className='d-block w-100' src={pliermage2} alt="First Image Project" />
                        </div>

                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
                <h2 className="text-white py-3">To Lessen The Effort</h2>
            </div>
            <iframe className='embeded-frame py-3' src="https://myhub.autodesk360.com/ue2a4d27f/shares/public/SH919a0QTf3c32634dcffb0229206f7e5ff1?mode=embed"   width="900" height="700" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0"></iframe>
            <div className="project-video py-4">
                <iframe class='embeded-frame' width="900" height="700" src="https://www.youtube.com/embed/k09tr2Dks-Y" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
           

        </div>
    )
}

export default Plier
